<template>
  <div class="algorithm-value-notice">
    <span class="notice-dot"></span>
    <span>{{ text }}</span>
  </div>
</template>

<script>
import { VALUE_NOTICE_TEXT } from '@/constants/compliance';

export default {
  name: 'AlgorithmValueNotice',
  data() {
    return {
      text: VALUE_NOTICE_TEXT
    };
  }
};
</script>

<style scoped lang="scss">
.algorithm-value-notice {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin: 8px 16px 12px;
  padding: 0 2px;
  color: #748095;
  font-size: 12px;
  line-height: 1.65;
}

.notice-dot {
  flex: 0 0 auto;
  width: 5px;
  height: 5px;
  margin-top: 8px;
  border-radius: 50%;
  background: #9bb8ff;
}
</style>
